export default "__VITE_ASSET__B0X2P1Vm__"